import React from "react";
import styled from "styled-components";

import { PaginatedSort } from "common/interfaces";

import { FilterDropDown } from "../../AddSlide/Panes/Components/FilterDropDown";
import { SearchBarInnerContainer, SlideSearchInput } from "../../AddSlide/Panes/Components/SearchBox";
import { SortMenu } from "../../AddSlide/Panes/Components/SortMenu";

export type SearchBarFilterOption = {
    field: string;
    label: string;
};

export type SearchBarSort = PaginatedSort & {
    label?: string;
    icon?: React.ReactNode;
};

export type SearchBarProps = {
    query: string;
    onSearch: (query: string) => void;
    searchPlaceholder: string;
    contentFilterOptions?: SearchBarFilterOption[];
    selectedContentFilter?: string;
    onContentFilterChange?: (event: { target: { value: string } }) => void;
    tagFilterOptions: SearchBarFilterOption[];
    selectedTagFilter: string;
    onTagFilterChange: (event: { target: { value: string } }) => void;
    sortOptions: SearchBarSort[];
    sort: SearchBarSort;
    onSetSort: (sort: SearchBarSort) => void;
    sortDisabled?: boolean;
    className?: string;
};

const SearchBarOuter = styled.div`
    width: 100%;
    box-sizing: border-box;
`;

const StyledFilterDropDown = styled(FilterDropDown)`
    &&& {
        .MuiSelect-select {
            color: #444;
            font-family: "Source Sans Pro";
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 15px;
            text-transform: uppercase;
        }
    }
`;

const StyledSearchInput = styled(SlideSearchInput)`
    &&& {
        input[type="text"] {
            color: #888;
            font-family: "Source Sans Pro";
            font-size: 18px;
            font-style: italic;
            font-weight: 400;
            line-height: 125%;
            letter-spacing: 0.5px;
        }

        .MuiIcon-root {
            font-size: 30px;
        }
    }
`;

export default function SearchBar({
    query,
    onSearch,
    searchPlaceholder,
    contentFilterOptions,
    selectedContentFilter,
    onContentFilterChange,
    tagFilterOptions,
    selectedTagFilter,
    onTagFilterChange,
    sortOptions,
    sort,
    onSetSort,
    sortDisabled = false,
    className
}: SearchBarProps) {
    return (
        <SearchBarOuter className={className}>
            <SearchBarInnerContainer>
                <StyledSearchInput
                    query={query}
                    onSearch={onSearch}
                    placeholder={searchPlaceholder}
                />
                {contentFilterOptions && onContentFilterChange && selectedContentFilter != null && (
                    <StyledFilterDropDown
                        onChange={onContentFilterChange}
                        selectedFilter={selectedContentFilter}
                        filterOptions={contentFilterOptions}
                    />
                )}
                <StyledFilterDropDown
                    onChange={onTagFilterChange}
                    selectedFilter={selectedTagFilter}
                    filterOptions={tagFilterOptions}
                />
                <SortMenu
                    disabled={sortDisabled}
                    sortOptions={sortOptions}
                    selectedField={sort?.field}
                    onSetSort={onSetSort}
                />
            </SearchBarInnerContainer>
        </SearchBarOuter>
    );
}
